import { loadScript } from 'common/utils/loadScript';
import { configuration } from 'config/constants';

if (!window.SGWTWidgetDependencies) {
    window.SGWTWidgetDependencies = { dependencies: [] };
}

export enum WidgetName {
    arclabButtonGroup = 'arclab-button-group',
    arclabPicker = 'arclab-picker',
    arclabSelect = 'arclab-select',
    idyRequestAccess = 'idy-request-access',
    arclabCheckbox = 'arclab-checkbox',
}

export async function injectWidget(widgetName: WidgetName): Promise<void> {
    const sgwtWidgetDependencies = window.SGWTWidgetDependencies;
    let widgetUrl;

    switch (widgetName) {
        case WidgetName.arclabButtonGroup:
            widgetUrl = configuration.componentUrls.arclabButtonGroup;
            break;

        case WidgetName.arclabPicker:
            widgetUrl = configuration.componentUrls.arclabPicker;
            break;

        case WidgetName.arclabSelect:
            widgetUrl = configuration.componentUrls.arclabSelect;
            break;

        case WidgetName.idyRequestAccess:
            widgetUrl = configuration.componentUrls.idyRequestAccess;
            break;
        
        case WidgetName.arclabCheckbox:
            widgetUrl = configuration.componentUrls.arclabCheckbox;
            break;

        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const exhaustiveCheck: never = widgetName;
    }

    if (widgetName && widgetUrl) {
        // check if widget have already been loaded
        // or if widget tag is already know as a webcomponent (through customElements)
        // for more info on customElements see https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry
        if (sgwtWidgetDependencies?.dependencies && sgwtWidgetDependencies.dependencies.indexOf(widgetName) < 0 && customElements.get(widgetName) === undefined
        ) {
            sgwtWidgetDependencies?.dependencies.push(widgetName); // Add the current widget name
            await loadScript(widgetName, widgetUrl);
        }
    }
}
